import { render, staticRenderFns } from "./NewAchAccount.vue?vue&type=template&id=600470f5&scoped=true&"
import script from "./NewAchAccount.vue?vue&type=script&lang=js&"
export * from "./NewAchAccount.vue?vue&type=script&lang=js&"
import style0 from "./NewAchAccount.vue?vue&type=style&index=0&id=600470f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600470f5",
  null
  
)

export default component.exports